import React, { Component } from 'react';

class FlashForm extends Component
{
    constructor(props)
    {
        super(props);

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    render()
    {
        return (
            <div className="fade modal show" id="addFlashModal" tabIndex="-1" role="dialog" aria-labelledby="addFlashModalLabel" aria-modal="true">
                <div className="modal-dialog modal-full-height modal-right" role="document">
                    <div className="modal-content rounded-0 p-3">
                        <button type="button" className="close closeSideModal" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="modal-header">
                            <h4 className="modal-title" id="addFlashModalLabel">Ajouter un flash</h4>

                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col">
                                    <label className="h5 font-weight-bold">
                                        Modèle
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="text" maxLength="100" className="form-control" name="model" value={ this.props.flash.model } onChange={ this.handeInput } />
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir moins de 100 caractères.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Marge
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" step="0.01" className="form-control" name="margin" value={ this.props.flash.margin } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        BMOD
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" step="0.01" className="form-control" name="bmod" value={ this.props.flash.bmod } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€ / %</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Reprise
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="takeover" value={ this.props.flash.takeover } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Reprise > 12 ans
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="takeover_twelve" value={ this.props.flash.takeover_twelve } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Reprise conquête
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="takeover_conquest" value={ this.props.flash.takeover_conquest } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Reprise fidé
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="takeover_loyalty" value={ this.props.flash.takeover_loyalty } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Booster commandes immat
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="booster" value={ this.props.flash.booster } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Destock
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="destocking" value={ this.props.flash.destocking } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Pool
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" className="form-control" name="pool" value={ this.props.flash.pool } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">€</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        Parc essai
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" step="0.01" className="form-control" name="test_park" value={ this.props.flash.test_park } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                    <label className="h5 font-weight-bold">
                                        SO
                                    </label>
                                    <div className="input-group mb-3">
                                        <input type="number" min="0" step="0.01" className="form-control" name="so" value={ this.props.flash.so } onChange={ this.handeInput } />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                        <small className="text-danger form-text">
                                            Ce champ doit contenir un nombre supérieur à 0.
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className='btn btn-primary float-right' onClick={()=> this.props.onSubmit()}>
                                <li className='fas fa-save'> </li> Enregistrer
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FlashForm;


// WEBPACK FOOTER //
// ./src/Components/Flash/FlashForm.js